import { render, staticRenderFns } from "./BrandBuilder.vue?vue&type=template&id=3a286b8a&scoped=true&"
import script from "./BrandBuilder.vue?vue&type=script&lang=js&"
export * from "./BrandBuilder.vue?vue&type=script&lang=js&"
import style0 from "./BrandBuilder.vue?vue&type=style&index=0&id=3a286b8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a286b8a",
  null
  
)

export default component.exports